module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-slideshow u-relative"
  }, [_c('a', {
    staticClass: "c-slideshow__left--container u-block u-absolute u-pos-tl u-w1of9",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm._goto(_vm.currentImg - 1)
      }
    }
  }, [_c('img', {
    staticClass: "u-absolute u-pos-l u-pos-y-center",
    attrs: {
      "src": require("../../../assets/icon/icon-arrow-left--outline.png"),
      "alt": "Previous"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "c-slideshow__right--container u-block u-absolute u-pos-tr u-w1of9",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm._goto(_vm.currentImg + 1)
      }
    }
  }, [_c('img', {
    staticClass: "u-absolute u-pos-r u-pos-y-center",
    attrs: {
      "src": require("../../../assets/icon/icon-arrow-right--outline.png"),
      "alt": "Next"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "c-slideshow__center--container o-list--none u-absolute u-pos-t u-w7of9"
  }, [_c('transition', {
    attrs: {
      "name": "c-slideshow__slide"
    }
  }, _vm._l((_vm.content), function(data, i) {
    return (i === _vm.currentImg) ? _c('li', {
      key: i,
      staticClass: "c-slideshow__slide u-absolute u-pos-tl u-fit"
    }, [_c('div', {
      staticClass: "o-box--16by9 u-marg-b-lg"
    }, [_c('app-img-bg', {
      attrs: {
        "src": data.img
      }
    })], 1), _vm._v(" "), _c('p', {
      staticClass: "t-text--lg c-color--gray-light"
    }, [_c('span', {
      staticClass: "u-marg-r-xxs"
    }, [_vm._v(_vm._s((i + 1)))]), _vm._v(" "), _c('span', {
      staticClass: "u-marg-r-xxs"
    }, [_vm._v("/")]), _vm._v(" "), _c('span', {
      staticClass: "u-marg-r-xl"
    }, [_vm._v(_vm._s(_vm.content.length))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(data.alt)
      }
    })])]) : _vm._e()
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dfb5582"}!./src/scripts/components/app-slideshow/template.html
// module id = 899
// module chunks = 0